export default "__VITE_ASSET__Bm8GPi0$__"